export default __webpack_public_path__ + "static/media/footme.95802240.jpg";